/*
 * Replacing the whole list (delete all, restoring saved plays) shows the new plays in place.
 * Sliding every play in and out would read as plays being added one after another.
 */
export const useEditorPlayListAnimation = () => {
  const animated = useState('editor-play-list-animated', () => true)

  const withoutAnimation = (change: () => void) => {
    animated.value = false
    change()
    void nextTick(() => {
      animated.value = true
    })
  }

  return { animated: readonly(animated), withoutAnimation }
}
